"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutItemBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
/**
 * @alpha
 */
var DashboardLayoutItemBuilder = /** @class */ (function () {
    function DashboardLayoutItemBuilder(setSection, getItemFacade, itemIndex) {
        this.setSection = setSection;
        this.getItemFacade = getItemFacade;
        this.itemIndex = itemIndex;
    }
    /**
     * Creates an instance of DashboardLayoutItemBuilder for particular layout item.
     *
     * @param item - item to modify
     */
    DashboardLayoutItemBuilder.for = function (sectionBuilder, itemIndex) {
        var _a;
        ts_invariant_1.default(sdk_backend_spi_1.isDashboardLayoutItem((_a = sectionBuilder.facade().item(itemIndex)) === null || _a === void 0 ? void 0 : _a.raw()), "Provided data must be IDashboardLayoutItem! " + itemIndex + " " + sectionBuilder
            .facade()
            .item(itemIndex));
        return new DashboardLayoutItemBuilder(function (section) { return sectionBuilder.setSection(section); }, function () { return sectionBuilder.facade().item(itemIndex); }, itemIndex);
    };
    DashboardLayoutItemBuilder.prototype.size = function (valueOrUpdateCallback) {
        this.setItem(function (item) { return (tslib_1.__assign(tslib_1.__assign({}, item), { size: sdk_backend_base_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, item.size) })); });
        return this;
    };
    DashboardLayoutItemBuilder.prototype.widget = function (valueOrUpdateCallback) {
        this.setItem(function (item) { return (tslib_1.__assign(tslib_1.__assign({}, item), { widget: sdk_backend_base_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, item.widget) })); });
        return this;
    };
    DashboardLayoutItemBuilder.prototype.setItem = function (valueOrUpdateCallback) {
        var _this = this;
        this.setSection(function (section) {
            var updatedItems = tslib_1.__spreadArrays(section.items);
            updatedItems[_this.itemIndex] = sdk_backend_base_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, _this.build());
            return tslib_1.__assign(tslib_1.__assign({}, section), { items: updatedItems });
        });
        return this;
    };
    DashboardLayoutItemBuilder.prototype.modify = function (modifications) {
        modifications(this, this.facade());
        return this;
    };
    DashboardLayoutItemBuilder.prototype.build = function () {
        return this.facade().raw();
    };
    DashboardLayoutItemBuilder.prototype.facade = function () {
        return this.getItemFacade();
    };
    DashboardLayoutItemBuilder.prototype.newInsightWidget = function (insight, create) {
        if (create === void 0) { create = identity_1.default; }
        this.widget(create(sdk_backend_base_1.InsightWidgetBuilder.forNew(insight)).build());
        return this;
    };
    DashboardLayoutItemBuilder.prototype.modifyInsightWidget = function (modify) {
        var content = this.facade().widget();
        ts_invariant_1.default(sdk_backend_spi_1.isInsightWidgetDefinition(content) || sdk_backend_spi_1.isInsightWidget(content), "Content of the item is not a kpi widget!");
        this.widget(modify(sdk_backend_base_1.InsightWidgetBuilder.for(content)).build());
        return this;
    };
    DashboardLayoutItemBuilder.prototype.newKpiWidget = function (measure, create) {
        if (create === void 0) { create = identity_1.default; }
        this.widget(create(sdk_backend_base_1.KpiWidgetBuilder.forNew(measure)).build());
        return this;
    };
    DashboardLayoutItemBuilder.prototype.modifyKpiWidget = function (modify) {
        var content = this.facade().widget();
        ts_invariant_1.default(sdk_backend_spi_1.isKpiWidgetDefinition(content) || sdk_backend_spi_1.isKpiWidget(content), "Content of the item is not a kpi widget!");
        this.widget(modify(sdk_backend_base_1.KpiWidgetBuilder.for(content)).build());
        return this;
    };
    return DashboardLayoutItemBuilder;
}());
exports.DashboardLayoutItemBuilder = DashboardLayoutItemBuilder;
//# sourceMappingURL=item.js.map